// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 912) return "wp-content/themes/arc/dist/js/912.js";
	if (chunkId === 791) return "wp-content/themes/arc/dist/js/791.js";
	// return url for filenames based on template
	return undefined;
};